import { ColumnsType } from "antd/es/table";
import BodyTable from "../../components/GlobalTable/BodyTable";
import { IoIosArrowForward } from "react-icons/io";
import { Button, Form, Input, InputNumber } from "antd";
import { useSelector } from "react-redux";
import AntTable from "../../components/AntTable/AntTable";
import { useNavigate } from "react-router-dom";

type Props = {};

const NewStocktaking = (props: Props) => {
  const navigate = useNavigate();
  const { NewStocktaking } = useSelector((e: any) => e.settings);
  const getStatusStyles = (status: any) => {
    let color = ""; // Define an empty color variable

    switch (status) {
      case "تمت":
        color = "#479821"; // Color for "تمت"
        break;
      case "تم الانشاء":
        color = "#00086D"; // Color for "تم الانشاء"
        break;
      case "جاريه":
        color = "#CF953D"; // Color for "جاريه"
        break;
      default:
        color = "#00086D"; // Default color if status doesn't match any case
        break;
    }

    return { color }; // Return an object with the color property
  };
  const data = [
    {
      key: "1231",
      id: 101,
      name: "لوريال - بسلم",
      exception: "200",
    },
    {
      key: "1232",
      id: 102,
      name: "لوريال - بسلم",
      exception: "200",
    },
    {
      key: "1233",
      id: 103,
      name: "لوريال - بسلم",
      exception: "200",
    },
    {
      key: "1234",
      id: 104,
      name: "لوريال - بسلم",
      exception: "200",
    },
  ];
  const columns: ColumnsType<any> = [
    {
      title: <div className="bg-[#eef0ff] w-full h-full py-1">اسم المنتج</div>,
      render: (text: any, record: any) => {
        const style = getStatusStyles(record.status);
        return (
          <div
            className={`py-4 h-[72px] min-w-[100px]  text-center flex items-center justify-center border-b-0 bg-white !rounded-r-lg !pt-[15px] mr-[1px] text-color-primary text-sm font-semibold border-l-[0px] border-r-[1px] border-solid`}
            style={{ ...style, border: `0px ${style.color} solid` }}
          >
            {record?.name}
          </div>
        );
      },
    },
    {
      title: (
        <div className="bg-[#eef0ff] text-[#75757E]  h-full py-1">المتوقع</div>
      ),
      render: (text: any, record: any) => {
        const style = getStatusStyles(record.status);
        return (
          <div
            className={`py-4 h-[72px] min-w-[100px] flex items-center justify-center !pt-[15px] bg-white border-solid border-[${style.color}] border-b-0 border-r-0 border-l-0 w-full text-[#9999A7] text-sm font-medium`}
            style={{ ...style, border: `0px ${style.color} solid` }}
          >
            <div className="text-color-primary rounded-lg w-[120px] bg-[#EEF0FF] my-2 text-sm font-medium py-[12px] px-[10px]">
              {record?.exception}
            </div>
          </div>
        );
      },
    },
    {
      title: <div className="bg-[#eef0ff] h-full py-1">الجرد الفعلي</div>,
      render: (text: any, record: any) => {
        const style = getStatusStyles(record.status);
        return (
          <Form.Item name={`${record.id} 22`} className="">
            <div
              className={`py-4 h-[72px] min-w-[100px] px-2 !pt-[15px] flex items-center justify-center bg-white border-solid border-[${style.color}] border-b-0 border-r-0 border-l-0 text-[#9999A7] text-sm rounded-l-lg font-medium`}
              style={{ ...style, border: `0px ${style.color} solid` }}
            >
              <div className="flex items-center">
                <InputNumber />
              </div>
            </div>
          </Form.Item>
        );
      },
    },
  ];
  console.log(NewStocktaking);
  const onFinish = (values: any) => {
    console.log(values);
  };
  return (
    <Form
      name="NewStocktaking"
      onFinish={onFinish}
      layout={"vertical"}
      className="w-full"
      dir="rtl"
    >
      <div className="bg-[#EEF0FF] px-6 py-4 pb-8 rounded-lg newStocking">
        <div className="mb-8">
          <span className="flex items-center mb-6" onClick={() => navigate(-1)}>
            <IoIosArrowForward className="text-[#75757E]" />
            <span>جرد المخزون</span>
          </span>
          <h4 className="text-color-primary text-2xl font-semibold mb-4">
            جرد جاري - ( {NewStocktaking.name} )
          </h4>
          <p className="text-[#75757E] font-normal text-base">
            قم بادخال معلومات الجرد ثم الحفظ
          </p>
        </div>
        <AntTable
          tableColumns={columns}
          tableData={data || []}
          hideArrowExpand
          isLoading={false}
        />
        <div className="w-full flex gap-2 items-center justify-end mt-auto max-lg:mt-2">
          <div className="w-full"></div>
          <Button type="primary" htmlType="submit" className="lg:w-1/2">
            تم الجرد
          </Button>
          <Button type="default" className="lg:w-1/4">
            حفظ كمسودة
          </Button>
          <Button className="bg-[#EEF0FF] lg:w-1/4">إلغاء</Button>
        </div>
      </div>
    </Form>
  );
};

export default NewStocktaking;
